
import {
  Vue, Component, Prop, Watch 
} from 'vue-property-decorator';

@Component
export default class ExModalDefault extends Vue {
  @Prop({ required: true }) modelValue!: boolean;

  dialog: boolean = this.modelValue;

  @Watch('modelValue', { immediate: true })
  onModelValueChanged(val: boolean) {
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChanged(val: boolean) {
    if (val !== this.modelValue) {
      this.$emit('update:modelValue', val);
    }
  }

  close() {
    this.dialog = false;
  }
}
